import React from 'react';
import { DetailCardContainer, DetailCardText } from './styles';
import { Tag } from '@gerdau/hefesto-mais-web';
import {
  StatusType,
  statusVariantMap
} from '../../../../store/ducks/manifestations/types';

interface Props {
  title: string;
  subtitle: string;
  withTag?: boolean;
}

export const DetailCard = (data: Props) => {
  const renderSubtitle = () => {
    if (data.withTag) {
      return (
        <Tag variant={statusVariantMap[data.subtitle as StatusType]}>
          {data.subtitle}
        </Tag>
      );
    }

    return data.subtitle;
  };

  return (
    <DetailCardContainer>
      <DetailCardText bold>{data.title}</DetailCardText>
      <DetailCardText>{renderSubtitle()}</DetailCardText>
    </DetailCardContainer>
  );
};
